<template>
    <div>
        <v-dialog v-model="imgdialog" max-width="450px">
            <v-card tile>
                <v-card-text>
                    <v-container>
                        <v-img contain max-height="150" :src="selectedSrc"></v-img>
                    </v-container>
                </v-card-text>

                <v-divider class="primary" />
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="error" @click="() => { imgdialog = false }">
                        Back
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" max-width="450px" persistent>
            <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                    <v-icon dark>
                        mdi-plus
                    </v-icon>
                    Create
                </v-btn>
            </template>
            <v-card tile>
                <v-card-title class="primary white--text">
                    <span class="text-h5"><v-icon large color="white" class="mr-2">{{ formIcon }}</v-icon>{{ formTitle
                    }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="12" class="my-2 d-flex justify-center" v-if="selectedImage">
                                <v-img contain max-height="150" :src="selectedImage"></v-img>
                            </v-col>
                            <v-col cols="12">
                                <v-file-input label="Cover" outlined dense @change="getImage" v-model="editedItem.image_url"
                                    prepend-icon="" append-icon="mdi-image"></v-file-input>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field outlined dense v-model="editedItem.name" :error-messages="nameErrors" required
                                    @input="editedIndex == -1 ? $v.editedItem.name.$touch() : null"
                                    @blur="editedIndex == -1 ? $v.editedItem.name.$touch() : null" label="Name"
                                    append-icon="mdi-rename-box"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field outlined dense type="date" v-model="editedItem.date"
                                    :error-messages="bannerAdsDateErrors" required
                                    @input="editedIndex == -1 ? $v.editedItem.date.$touch() : null"
                                    @blur="editedIndex == -1 ? $v.editedItem.date.$touch() : null"
                                    label="Date"></v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field outlined dense v-model="editedItem.link" label="Link"
                                    append-icon="mdi-link"></v-text-field>
                            </v-col>
                            
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-alert v-if="error" dense type="error">
                                    {{ error }}
                                </v-alert>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-divider class="primary" />
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="error" @click="close">
                        Cancel
                    </v-btn>
                    <v-btn color="success" @click="save">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-card-title class="error white--text">
                    <v-icon color="white" class="mr-2">mdi-delete</v-icon>
                    You sure you want to delete this item?
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" @click="closeDelete">Cancel
                    </v-btn>
                    <v-btn color="success" @click="deleteItemConfirm">OK
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-data-table :headers="headers" :items="data" sort-by="calories" class="elevation-3">
            <template v-slot:item.image_url="{ item }">
                <v-avatar class="profile my-2" color="grey" size="80" tile @click="openImage(item.image_url)">
                    <v-img contain v-if="item.image_url" :src="item.image_url"></v-img>
                </v-avatar>
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon small @click="editItem(item)" class="error--text">
                    mdi-pencil
                </v-icon>
                <v-icon small @click="deleteItem(item)" class="error--text">
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:item.date="{ item }">
                <span> {{ item.date !== null && item.date !== undefined ?
                    moment(`${item.date}`).format('Do MMM YY') : '' }}</span>
            </template>
            <template v-slot:no-data>
                <v-progress-circular v-if="loading" indeterminate color="secondary"></v-progress-circular>

                <v-icon v-else x-large color="grey lighten-1">
                    mdi-tray-remove
                </v-icon>

            </template>
        </v-data-table>
    </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import moment from "moment";

export default {
    name: 'Banners',
    mixins: [validationMixin],
    data: () => ({
        imgdialog: false,
        selectedSrc: null,
        headers: [
            {
                text: 'Cover',
                value: 'image_url',
                sortable: false,
                align: 'start'
            },
            { text: 'Name', value: 'name' },
            { text: 'Date', value: 'date' },
            { text: 'Link', value: 'link' },
            { text: 'Actions', value: 'actions', sortable: false },
        ],
        data: [],
        apiUrl: process.env.VUE_APP_API_URL,
        loading: true,
        dialog: false,
        dialogDelete: false,
        error: '',
        editedIndex: -1,
        editedItem: {
            name: '',
            image_url: null,
            date: '',
            link: '',
        },
        defaultItem: {
            name: '',
            image_url: null,
            date: '',
            link: '',
        },
        selectedImage: null,
    }),
    created() {
        this.getBanners();
    },
    methods: {
        moment: function (b) {
            return moment(b);
        },
        openImage(src) {
            this.selectedSrc = src
            this.imgdialog = true
        },
        editItem(item) {
            this.selectedImage = item.image_url
            this.editedIndex = this.data.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        deleteItem(item) {
            this.editedIndex = this.data.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },
        deleteItemConfirm() {
            this.deleteBanner(this.editedItem.id)
            this.closeDelete();
        },
        close() {
            this.dialog = false;
            this.$v.$reset()
            this.error = ''
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        save() {
            this.editedIndex == -1 ? this.addBanner() : this.updateBanner()
        },
        //Banners API Calls
        getImage() {
            let formData = new FormData();
            formData.append('img', this.editedItem.image_url);

            this.$Axios({
                method: 'post',
                url: '/api/v1/util/upload-image',
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' },
            })
                .then(({ data }) => {
                    console.log(data)
                    this.selectedImage = data.img
                })
                .catch((e) => {
                    console.log(e)
                });
        },
        getBanners() {
            this.loading = true
            this.$Axios
                .get('/api/v1/banner/')
                .then((res) => {
                    this.data = res.data;
                })
                .catch((e) => {
                    console.log(e);
                })
                .finally(() => {
                    this.loading = false
                })
        },
        addBanner() {

            this.error = ''
            this.$v.$touch()
            console.log(this.$v)
            if (this.$v.$error) {
                return
            }
            let data = {}
            data.name = this.editedItem.name
            data.date = this.editedItem.date
            data.image_url = this.selectedImage
            data.link = this.editedItem.link


            this.$Axios
                .post('/api/v1/banner/', data)
                .then(() => {
                    this.getBanners();
                    this.close();
                })
                .catch((e) => {
                    console.log(e)
                });
        },
        updateBanner() {
            this.error = ''
            this.$v.$touch()

            if (this.$v.$error) {
                return
            }
            let formData = new FormData();
            if (this.editedItem.name) formData.append('name', this.editedItem.name);
            if (this.editedItem.image_url) formData.append('image_url', this.selectedImage);
            if (this.editedItem.date) formData.append('date', this.editedItem.date);
            if (this.editedItem.font_colour) formData.append('font_colour', this.editedItem.font_colour);
            if (this.editedItem.political_party) formData.append('political_party', this.editedItem.political_party)
            if (this.editedItem.type) formData.append('type', this.editedItem.type);
            if (this.editedItem.link) formData.append('link', this.editedItem.link);
            console.log('adding item : ', formData);
            this.$Axios({
                method: 'put',
                url: '/api/v1/banner/' + this.editedItem.id,
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' },
            })
                .then(() => {
                    this.getBanners();
                    this.close();
                })
                .catch((e) => {
                    console.log(e)
                });
        },
        deleteBanner(id) {
            this.$Axios
                .delete('/api/v1/banner/' + id)
                .then(() => {
                    this.getBanners();
                })
                .catch((e) => {
                    console.log(e);
                })
        },
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'New Banner' : 'Edit Banner';
        },
        formIcon() {
            return this.editedIndex === -1 ? 'mdi-plus' : 'mdi-edit';
        },
        filtredItems() {
            if (this.filter) return this.desserts.filter(item => item.name.includes(this.filter) || item.license.includes(this.filter) || item.email.includes(this.filter) || item.db.includes(this.filter))
            else return this.desserts
        },
        //// Vuelidate Errors
        nameErrors() {
            const errors = []
            if (!this.$v.editedItem.name.$dirty) return errors
            !this.$v.editedItem.name.required && errors.push('Name is required !')
            return errors
        },
        bannerAdsDateErrors() {
            const errors = []
            if (!this.$v.editedItem.date.$dirty) return errors
            !this.$v.editedItem.date.required && errors.push('Banner Date is required !')
            !this.$v.editedItem.date.date && errors.push('Banner Date must be YYYY-MM-DD')
            return errors
        },
        image_urlErrors() {
            const errors = []
            if (!this.$v.editedItem.image_url.$dirty) return errors
            !this.$v.editedItem.image_url.required && errors.push('Cover is required !')
            return errors
        },
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },
    validations: {
        editedItem: {
            name: {
                required
            },
            image_url: {
                required,
            },
            date: {
                required,
                date: (value) => { return moment(value, 'YYYY-MM-DD', true).isValid() }
            }
        },
    },
};
</script>